import React from "react";

export default function ExamSkeletonLoader() {
  return (
    <div className="space-y-6 font-roboto animate-pulse w-[100%]">

      {/* Unlock Message */}
      <div className="bg-white border border-gray-300 rounded-md p-4 space-y-2">
        <div className="w-1/3 h-6 bg-gray-200 rounded" />
        <div className="w-2/3 h-4 bg-gray-100 rounded" />
        <div className="w-3/4 h-4 bg-gray-100 rounded" />
        <div className="w-4/4 h-4 bg-gray-100 rounded" />
      </div>

      {/* Question Cards (Repeat for multiple) */}
      {[1, 2, 3].map((q) => (
        <div key={q} className="bg-white border border-gray-300 rounded-md p-4 space-y-3">
          <div className="w-1/2 h-5 bg-gray-200 rounded" />
          {[1, 2, 3, 4].map((o) => (
            <div key={o} className="flex items-center space-x-2">
              <div className="w-4 h-4 bg-gray-300 rounded-full" />
              <div className="w-1/3 h-4 bg-gray-100 rounded" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
